// extracted by mini-css-extract-plugin
export default {"oneColumnLayout":"pHVlF","space":"mappo"};